// Granularity matrix from a reference's flags (fractionable, unitary) — the backend sends them per
// instance row of the load picker and the in-machine drill, but they are the same for every instance
// of a reference. They decide the per-instance input for partial load/return:
//   case 1 (!fractionable,  unitary) -> whole instance only (no partial)
//   case 2 (!fractionable, !unitary) -> partial integer (k of N)
//   case 3 ( fractionable,  unitary) -> partial decimal (fraction of the unit)
//   case 4 ( fractionable, !unitary) -> partial decimal
// If the flags are absent (older backend) we fall back to whole-instance only — the pre-existing
// behaviour — so the UI never sends a partial the server would reject.

export const allowsPartialQuantity = (flags = {}) => {
  if (flags.fractionable === true) return true
  if (flags.fractionable === false && flags.unitary === false) return true
  return false
}

export const allowsDecimalQuantity = (flags = {}) => flags.fractionable === true

// Normalizes an entered quantity to what the reference accepts (decimals rounded to 2, otherwise
// floored to an integer) and caps it at the instance's available quantity to avoid the backend
// PARTIAL_QUANTITY_EXCEEDS_INSTANCE. `available` undefined -> no cap.
export const normalizeInstanceQuantity = (value, { decimal = false, available } = {}) => {
  const raw = Number(value)
  if (!Number.isFinite(raw) || raw <= 0) return 0
  let quantity = decimal ? Math.round(raw * 100) / 100 : Math.floor(raw)
  if (available !== undefined && available !== null) quantity = Math.min(quantity, Number(available))
  return quantity > 0 ? quantity : 0
}
